import React from 'react';
import { StyledH2 } from '../../../Title/styles/Title.styled';
import {
    StyledFareSection,
    StyledFareSectionWrapper
} from './style/FareSection.styled';
import { FareCard } from './components/FareCard';
import { SubscriptionFares } from '../../../../lib/enums';

const yearFare = `
    background-image: image-set(
        url('assets/fare-card/fare-card-1-2x.webp') 1x type('image/webp'),
        url('assets/fare-card/fare-card-1-2x.png') 1x type('image/png'),
        url('assets/fare-card/fare-card-1-2x.webp') 2x type('image/webp'),
        url('assets/fare-card/fare-card-1-2x.png') 2x type('image/png'),
        url('assets/fare-card/fare-card-1-3x.webp') 3x type('image/webp'),
        url('assets/fare-card/fare-card-1-3x.png') 3x type('image/png')
    );
`;

const monthFare = `
    background-image: image-set(
        url('assets/fare-card/fare-card-2-2x.webp') 1x type('image/webp'),
        url('assets/fare-card/fare-card-2-2x.png') 1x type('image/png'),
        url('assets/fare-card/fare-card-2-2x.webp') 2x type('image/webp'),
        url('assets/fare-card/fare-card-2-2x.png') 2x type('image/png'),
        url('assets/fare-card/fare-card-2-3x.webp') 3x type('image/webp'),
        url('assets/fare-card/fare-card-2-3x.png') 3x type('image/png')
    );

`;

export const FareSection = () => {
    return (
        <StyledFareSectionWrapper>
            <StyledFareSection>
                <StyledH2 id="fare-section">Платите, как вам угодно</StyledH2>
                <div>
                    <FareCard
                        title="Подписка на месяц"
                        description="Слушайте музыку без рекламы за 99 ₽/месяц"
                        type={SubscriptionFares.MONTH}
                        linkText="Оформить подписку"
                        specificCss={monthFare}
                    />
                    <FareCard
                        title="Подписка на год"
                        description="Слушайте музыку без рекламы за 990 ₽/год"
                        type={SubscriptionFares.YEAR}
                        linkText="Оформить подписку"
                        specificCss={yearFare}
                    />
                </div>
            </StyledFareSection>
        </StyledFareSectionWrapper>
    );
};
